/**
 * Get the API URL based on environment
 * - Production: uses relative path (same domain)
 * - Development: uses localhost:3000
 */
export const getApiUrl = (): string => {
  // Check if VITE_API_URL is explicitly set (including empty string)
  if (import.meta.env.VITE_API_URL !== undefined) {
    return import.meta.env.VITE_API_URL;
  }

  // Check if running on localhost (development)
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  return isLocalhost ? 'http://localhost:3000' : '';
};

/**
 * Get the WebSocket URL based on environment
 * - Production: uses current domain with wss/ws based on protocol
 * - Development: uses ws://localhost:3000
 */
export const getWsUrl = (): string => {
  // Check if VITE_WS_URL is explicitly set (including empty string)
  if (import.meta.env.VITE_WS_URL !== undefined) {
    return import.meta.env.VITE_WS_URL;
  }

  // Check if running on localhost (development)
  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalhost) {
    return 'ws://localhost:3000';
  }

  // Production: use current domain
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};
